import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnInit } from '@angular/core';
import { ModalConfig } from '../../../model/modal-config';
import { PageNames } from '../../../shared/page-names.enum';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { Error } from '../../../model/error';
var OrderFailedComponent = /** @class */ (function () {
    function OrderFailedComponent(navigationService, changeDetector) {
        this.navigationService = navigationService;
        this.changeDetector = changeDetector;
        this.emitOnBack = new EventEmitter();
        this.emitCloseOrderFailed = new EventEmitter();
        this.componentName = PageNames.ORDERING_FAILED;
    }
    OrderFailedComponent.prototype.ngOnInit = function () {
        this.setLabel(this.error);
    };
    OrderFailedComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
        this.changeDetector.detectChanges();
    };
    OrderFailedComponent.prototype.onEmitCloseOrderFailed = function () {
        this.emitCloseOrderFailed.emit(true);
    };
    OrderFailedComponent.prototype.onBack = function () {
        this.emitOnBack.emit({
            value: true
        });
    };
    OrderFailedComponent.prototype.setLabel = function (error) {
        if (error.isOrderPending()) {
            this.label = OrderFailedComponent.PENDING;
        }
        else if (error.isReachCheckFailed()) {
            this.label = OrderFailedComponent.REACH_CHECK_FAILED;
        }
        else if (error.isWaitingActivation()) {
            this.label = OrderFailedComponent.STREAMING_BUNDLE_WAITING_ACTIVATION;
        }
        else {
            this.label = OrderFailedComponent.FAILED;
        }
    };
    OrderFailedComponent.FAILED = 'eos-tv-shop-ii.text.order-failed';
    OrderFailedComponent.REACH_CHECK_FAILED = 'eos-tv-shop-ii.text.order-reach-check-description';
    OrderFailedComponent.STREAMING_BUNDLE_WAITING_ACTIVATION = 'eos-tv-shop-ii.text.streaming-bundle-waiting-activation';
    OrderFailedComponent.PENDING = 'eos-tv-shop-ii.text.order-is-pending';
    return OrderFailedComponent;
}());
export { OrderFailedComponent };
